<template>
  <div class="bg-push-cream">
    <div class="container mx-auto flex flex-wrap">
      <div class="w-full md:w-1/2 p-2 text-center">
        <div class="heading m-8">
          <b class="text-push-orange text-2xl flex mt-16">{{ header }}</b>
          <b class="text-push-gray text-md flex mt-4">Poll web link</b>
          <div class="bg-white p-4 text-left mt-4 w-11/12 text-push-gray">
            {{ base + url }}
          </div>
          <div class="flex">
            <button
              class="flex px-6 py-2 mt-6 text-push-blue border-push-blue border"
              v-clipboard:copy="base + url"
              v-on:click="handleUrlCopyStatus"
            >
              <span v-if="copyUrlSucceeded === false">Copy Link!</span>
              <span v-if="copyUrlSucceeded === true">Copied!</span>
            </button>
            <a
              v-bind:href="'mailto:?subject=Push Poll:&body=' + url"
              class="flex px-6 py-2 mt-6 ml-6 text-white border-black border bg-push-black"
              >Attach to email</a
            >
          </div>
          <b class="text-push-gray flex mt-4">Embed code</b>
          <div
            class="container text-left bg-white w-11/12 p-3 mt-4 text-push-gray"
          >
            {{ iframe }}
          </div>
          <button
            class="flex px-6 py-2 mt-6 text-push-blue border-push-blue border"
            v-clipboard:copy="iframe"
            v-on:click="handleCodeCopyStatus"
          >
            <span v-if="copyCodeSucceeded === false">Copy Code!</span>
            <span v-if="copyCodeSucceeded === true">Copied!</span>
          </button>
        </div>
      </div>
      <div class="w-full md:w-1/2 bg-push-black">
        <div class="m-16">
          <b class="text-push-orange text-2xl flex mt-12">Whats next?</b>
          <p class="text-left text-white mt-4 m-1 mb-8">
            Go to your dashboard to review or edit current and past polls. Or
            have more burning questions to ask? - create another poll
          </p>
          <p class="text-left text-white mt-4 m-1">
            <router-link
              class="border-push-blue border bg-push-blue text-white p-2 mr-4 rounded-sm"
              :to="{ name: 'home' }"
              >Go to dashboard</router-link
            >
            <router-link
              class="border-push-blue border bg-push-blue text-white p-2 rounded-sm"
              :to="{ name: 'add-poll' }"
              >Create another poll</router-link
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase, { functions } from "firebase";
import moment from "moment";
// Content
// import SignIn from '@/components/content/SignIn.vue'

export default {
  components: {},
  data() {
    return {
      code: null,
      base: null,
      pollData: null,
      header: "Your poll has been created",
      promo: "Add a splash of colour and a dash of dazzle to your polls",
      url: null,
      iframe: null,
      copyUrlSucceeded: false,
      copyCodeSucceeded: false,
      quickCreate: null,
      email: null,
      question: null,
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
      uid: null
    };
  },
  watch: {
    $route(to, from) {
      var code = this.$route.params.fireId;
    }
  },
  methods: {
    handleUrlCopyStatus(status) {
      this.copyUrlSucceeded = true;
    },

    handleCodeCopyStatus(status) {
      this.copyCodeSucceeded = true;
    },

    getQuickData: function(e) {
      var email = localStorage.getItem("email");
      var quick = localStorage.getItem("quick");
      if (quick) {
        this.quickCreate = true;
      }

      if (email) {
        this.email = email;
      }
    },

    getHumanDate: function(date) {
      return moment(date, "YYYY-MM-DD").format("LLL");
    },

    getCreatedPoll: function() {
      var vm = this;
      var pollKey = this.code;
      //console.log(pollKey);
      var firestore = firebase.firestore();
      var docRef = firestore.doc("polls/" + pollKey);

      docRef
        .get()
        .then(
          function(doc) {
            if (doc.exists) {
              //this.pollData = doc.data();
              this.url = doc.data().name;
              this.question = doc.data().question;
              this.startDate = doc.data().startDate;
              this.endDate = doc.data().endDate;
              this.startTime = doc.data().startTime;
              this.endTime = doc.data().endTime;
              this.uid = doc.data().uid;

              this.renderIframe();
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
          }.bind(vm)
        )
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    },

    renderIframe: function() {
      var theurl = "https://" + this.base + this.url;
      var string =
        '<iframe width="100%" height="750" frameborder=0 src="' +
        theurl +
        '" name="push_embed"></iframe>';
      this.iframe = string;
    },

    getBaseurl: function() {
      const base = window.location.host;
      this.base = "https://" + base + "/polls/";
    }
  },
  computed: {
    loggedIn: function() {
      return this.$store.getters.loggedIn;
    }
  },
  mounted() {
    this.code = this.$route.params.fireId;
    this.getBaseurl();
    this.getCreatedPoll();
    this.getQuickData();
  }
};
</script>

<style></style>
